// extracted by mini-css-extract-plugin
module.exports = {"overlay":"overlay_overlay__lTRSv","overlay--after-open":"overlay_overlay--after-open__aD02P","overlay--before-close":"overlay_overlay--before-close__TU_OC"};